module.exports = __webpack_public_path__ + "static/media/BR 6.92336e32.mp3";